(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('ObservedData', ObservedData);

    ObservedData.$inject = ['$resource', 'DateUtils'];

    function ObservedData ($resource, DateUtils) {
        var resourceUrl =  'api/observed-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.settlementDate = DateUtils.convertLocalDateFromServer(data.settlementDate);
                        data.tradeDate = DateUtils.convertLocalDateFromServer(data.tradeDate);
                        data.inceptionDate = DateUtils.convertLocalDateFromServer(data.inceptionDate);
                        data.maturityDate = DateUtils.convertLocalDateFromServer(data.maturityDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.settlementDate = DateUtils.convertLocalDateToServer(copy.settlementDate);
                    copy.tradeDate = DateUtils.convertLocalDateToServer(copy.tradeDate);
                    copy.inceptionDate = DateUtils.convertLocalDateToServer(copy.inceptionDate);
                    copy.maturityDate = DateUtils.convertLocalDateToServer(copy.maturityDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.settlementDate = DateUtils.convertLocalDateToServer(copy.settlementDate);
                    copy.tradeDate = DateUtils.convertLocalDateToServer(copy.tradeDate);
                    copy.inceptionDate = DateUtils.convertLocalDateToServer(copy.inceptionDate);
                    copy.maturityDate = DateUtils.convertLocalDateToServer(copy.maturityDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
